import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/user';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { OnlyLNumbersValidator } from 'src/app/directives/only-numbers-validator.directive';
import { ClipboardService } from 'src/app/services/clipboard.service';
import { SettingsService } from '../../settings.service';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { IdentityWhitelabelApiClient } from 'src/app/services/api-clients/identity-whitelabel.api-client';
import { IdsForSettingsService, WhiteLabelInfoModel } from '../../ids-for-settings.service';

@Component({
  templateUrl: './settings-whitelabel-overview.page.html'
})
export class SettingsWhiteLabelOverviewPage implements OnInit, OnDestroy {

  selectedWhiteLabelId: string = "";
  whiteLabel!: any;
  user!: User;
  progressSubscription!: number;
  form: UntypedFormGroup;
  kvkNumberControl!: FormControl;
  signatureAmount: number = -1;
  remainingSignatures: number = -1;
  signatureProgress: number = 0;
  userCount: number = -1;
  organisationCount: number = -1;
  translations: any = <any>{};
  subdate: Date = new Date(Date.now());

  whiteLabelIdSubscription: Subscription;

  constructor(
    private translateService: TranslateService,
    private whiteLabelApiClient: IdentityWhitelabelApiClient,
    private formBuilder: UntypedFormBuilder,
    private clipboardService: ClipboardService,
    private idsForSettingsService: IdsForSettingsService,
    private settingsService: SettingsService,
    private settingsBreadCrumbService: SettingsBreadCrumbService) {

    // setup
    this.kvkNumberControl = new UntypedFormControl('', [OnlyLNumbersValidator(), Validators.minLength(8), Validators.maxLength(8)]);
    this.form = this.formBuilder.group({
      kvk: this.kvkNumberControl
    });
    // get data
    this.user = this.settingsService.user;
    this.whiteLabelIdSubscription = this.idsForSettingsService.selectedWhiteLabelId$.subscribe(whitelabelid => {
      if (whitelabelid === this.selectedWhiteLabelId) return;
      this.selectedWhiteLabelId = whitelabelid;

      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetWhiteLabelCrumbs(BreadCrumbOptions.Whitelabel_Overview(this.selectedWhiteLabelId));

      if (whitelabelid) {
        this.whiteLabelApiClient.getWhitelabel(whitelabelid).subscribe(whitelabelData => {
          this.whiteLabel = whitelabelData;
          this.remainingSignatures = 0;
          this.signatureAmount = 0;
          this.userCount = this.whiteLabel.amountOfUsers;
          this.whiteLabel.signingBundles.forEach((item: any) => {
            this.remainingSignatures += item.remainingSignatures;
            this.signatureAmount += item.signatureAmount;
          });
          this.signatureProgress = (this.remainingSignatures / (this.signatureAmount == 0 ? 1 : this.signatureAmount)) * 100;
          this.organisationCount = this.whiteLabel.whiteLabel?.organisations?.length;
          this.idsForSettingsService.setSelectedWhitelabel(new WhiteLabelInfoModel(this.whiteLabel.whiteLabel.guid, this.whiteLabel.whiteLabel.name));
        });
      }
    });
  }
  ngOnDestroy(): void {
    this.whiteLabelIdSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.getTranslations();
    this.translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
  }

  getTranslations() {
    this.translateService.get([
      'Toasts.Error',
      'Settings.OrganisationSection.KVKerror'
    ]).subscribe(translation => {
      this.translations.error = translation['Toasts.Error'];
      this.translations.KVKerror = translation['Settings.OrganisationSection.KVKerror'];
    });
  }

  copyWhiteLabelIdToClipboard() {
    this.clipboardService.Copy(this.selectedWhiteLabelId);
  }
}
